import { IEquipmentWeightInfo } from '../exercise';

export type TextInterpolationVariable =
  | 'seconds'
  | 'minutesUntilWorkoutEnds'
  | 'secondsUntilPhaseEnds'
  | 'zoneNumber'
  | 'machineName';

export enum ScheduleEntryColourCode {
    Rest,
    Play,
    Prepare,
}

export enum CustomIconName {
    Repeat = 'repeat',
    RepeatAndBuild = 'repeatAndBuild',
    RepeatAndBurn = 'repeatAndBurn',
    RepeatAndBalance = 'repeatAndBalance',
    OfflineMobilePhone = 'offlineMobilePhone',
    HeartRateNotConnected = 'HeartRateNotConnected',
    HeartRateConnected = 'HeartRateConnected',
    StartingBell = 'bell',
    PrepareWorkout = 'prepareWorkout',
    Exit = 'exit',
}

export enum AudioSoundEvent {
    silent = 'silent',
    startOfWorkout = 'startOfWorkoutBeep1',
    startOfRestPeriod = 'startOfRestPeriodBeep1',
    endOfWorkoutSession = 'endOfWorkoutSessionBeep1',
}

export enum Phase {
    Rest = 'Rest',
    Train = 'Train',
    ChangeZone = 'ChangeZone',
    MachineSetup = 'MachineSetup',
    MachineEnd = 'MachineEnd',
}

export enum ExerciseIndicatorLetter {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
}

export interface IAudioTip {
    fileName?: string;
    delay?: number;
    shouldNotPreload?: boolean;
}

export class SessionSequenceEntry {
    public durationInMilliseconds: number;
    public videoFile: string;
    public displayName: string;
    public displayBurnOrBuildIcon: boolean;
    public progressColourCode: ScheduleEntryColourCode;
    public progressText: string;
    public showProcessedMetrics: boolean;
    public showCalculatedMetrics: boolean;
    public customIcon?: CustomIconName;
    public audioSoundEvent?: AudioSoundEvent;
    public nonRepeatingSetupVideoFile?: string;
    public tips: string[];
    public zone: number;
    public quarter?: number;
    public phase: Phase;
    public playVideoFromCurrentSequenceDuration?: boolean = false;
    public exerciseVersion: string;
    public videoHasAudio?: boolean = false;
    public showLargeViewInGroupWorkout?: boolean = false;
    public showParticipantsInsteadOfTipsInGroupWorkout?: boolean = false;
    public audioTips?: IAudioTip[];
    public homeBenchInstructionImageUrl?: string;
    public techniqueTipAvailInstructors?: string[];
    public audioTipFileName?: string;
    public audioTipStartDelay?: number;
    public audioTipShouldCache?: boolean;
    public exerciseIndicatorLetter?: ExerciseIndicatorLetter;
    public exerciseFormatDescription?: string;
    public equipmentWeightInfo?: IEquipmentWeightInfo;
}
